import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
// import Layout from '../components/Layout'
import Layout from '../layouts'
import Img from 'gatsby-image'
import BlogRoll from '../components/BlogRoll'
import IntroBestseller from '../components/IntroBestseller'
import IntroSale from '../components/IntroSale'
import Contact from '../components/contact/index'
// import CustomLink from '../components/CustomLink'
// import styled from 'styled-components'
import FeaturedProducts from '~/components/ProductGridNewest'
import ProductCategories from '~/components/ProductCategories'
import AllProducts from '~/components/ProductGrid'
import GetStarted from '../components/GetStarted'

// const CustomLinkStyle = styled.div`
//   height: 250px;
//   box-shadow: 0 4px 15px 5px rgba(0,0,0,.25);
//   padding: 64px;
//   &:hover{
//     box-shadow: 0 4px 15px 5px rgba(0,0,0,.8);
//   }
// `

// const IOSWrap = styled.div`
//   padding-top: env(safe-area-inset-top);
//   padding-left: env(safe-area-inset-left);
//   padding-right: env(safe-area-inset-right);
//   padding-bottom: env(safe-area-inset-bottom);
// `

export const HomePageTemplate = ({
  home
}) => {
  return (
    <>
      {/*
      <div
        className='full-width-image margin-top-0'
        style={{
          backgroundImage: `url(${
            !!home.image.childImageSharp
              ? home.image.childImageSharp.fluid.src
              : home.image
            })`,
          backgroundPosition: 'center',
        }}
      />
      */}

      <div className='imageContainer' style={{ position: 'relative', height: '100vh' }}>
        <Img
          fluid={home.image.childImageSharp.fluid}
          style={{
            width: '100%',
            height: '100vh',
            position: 'fixed',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            filter: 'brightness(70%)'
          }}
        />
      </div>


        <section class='hero is-medium' style={{ position: 'absolute', top: '12%', marginLeft: 'auto', right: '0', width: '100%' }}>
          <div class='hero-body' style={{ paddingTop: '4rem', paddingBottom: '4rem' }}>
            <div class='container'>
              <h1 className='title is-2 is-uppercase has-text-centered text-shadow'>{home.mainpitch.title}
              </h1>
              <h2 class='subtitle is-5 is-uppercase has-text-centered text-shadow'>{home.mainpitch.subtitle}
              </h2>

              <div className='column has-text-centered' style={{ paddingTop: '4rem' }}>
                <Link className='button is-medium is-outlined is-primary is-inverted' to='/#intro'>
                  JETZT SHOPPEN
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className='section' style={{ marginBottom: '0px', position: 'relative' }}>
          <div className='columns is-multiline is-centered'>
            <IntroBestseller />
            <IntroSale />
            {/*
            <CustomLink
              linkType={home.callToActions.firstCTA.linkType}
              linkURL={home.callToActions.firstCTA.linkURL}
              className='column'
            >
              <CustomLinkStyle style={{ background: 'rgba(240,155,2,0.5)' }}>
                <h1 className='title'>{home.callToActions.firstCTA.heading}</h1>
                <p className='subtitle'>{home.callToActions.firstCTA.subHeading}
                </p>
              </CustomLinkStyle>
            </CustomLink>
            */}

            {/*
            <CustomLink
              linkType={home.callToActions.secondCTA.linkType}
              linkURL={home.callToActions.secondCTA.linkURL}
              className='column'
            >
              <CustomLinkStyle style={{ background: 'rgba(213,97,78,0.5)' }}>
                <h1 className='title'>{home.callToActions.secondCTA.heading}</h1>
                <p className='subtitle'>{home.callToActions.secondCTA.subHeading}</p>
              </CustomLinkStyle>
            </CustomLink>
            */}

          </div>
        </section>

        <FeaturedProducts />
        <ProductCategories />
        <AllProducts />

        <BlogRoll />
        <div className='column is-12 has-text-centered' style={{ background: '#161c27', position: 'relative' }}>
          <Link className='button is-medium is-outlined is-primary' to='/blog'>
            alle Stories
          </Link>
        </div>
        <Contact />
        <GetStarted />

    </>
  )
}

class HomePage extends React.Component {
  render () {
    const { data } = this.props
    const {
      data: { navbarData, footerData, bannerData, browserTab }
    } = this.props
    const { frontmatter: home } = data.homePageData.edges[0].node

    return (
      <Layout navbarData={navbarData} footerData={footerData} bannerData={bannerData} browserTab={browserTab}>
        <HomePageTemplate home={home} />
      </Layout>
    )
  }
}

HomePage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object
    })
  })
}

export default HomePage

export const pageQuery = graphql`
  query HomePageQuery {
    allMarkdownRemark {
      edges {
        node {
          frontmatter {
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 92) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            mainpitch {
              title
              subtitle
            }
          }
        }
      }
    }
    ...LayoutFragment
    homePageData: allMarkdownRemark(filter: { frontmatter: { templateKey: { eq: "home-page" } } }) {
      edges {
        node {
          frontmatter {
            image {
              childImageSharp {
                fluid(maxWidth: 2048, quality: 92) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
            mainpitch {
              title
              subtitle
            }
            callToActions {
              firstCTA {
                heading
                subHeading
                linkType
                linkURL
              }
              secondCTA {
                heading
                subHeading
                linkType
                linkURL
              }
            }
          }
        }
      }
    }
  }
`
